import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-bank-accounts-list',
  templateUrl: './../../../templates/forms/modals/bank-account-list.component.html',
})
export class BankAccountsListComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  accountsListModalExtarnalValue;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BankAccountsListGrid"
  chartOfAccountList: any[] = [];
  searchFields: any[] = ['BANK_ACC_NO', 'ACC_NAME', 'BRANCH_ADDR', 'BRANCH_NAME'];
  public searchString;

  constructor(public langService: LangService, private dataService: CommonService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.branchName, field: 'BRANCH_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.branchAddress, field: 'BRANCH_ADDR', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.accNo, field: 'BANK_ACC_NO', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.accName, field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    if (this.accountsListModalExtarnalValue == 1) {
      this.dataService.getBankAccountNames()
        .subscribe(arg => {
          this.chartOfAccountList = arg.body
        });
    }
    else {
      this.dataService.getMultiAccInfo()
        .subscribe(arg => {
          this.chartOfAccountList = arg.body
        });
    }
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }
}
